import {request} from './http.js'

export async function downloadInvoice(url, query) {
  const bytes = await request({url, method: 'get', params: {...query, download: '1'}, responseType: 'arraybuffer'})
  const signature = new TextDecoder().decode(new Uint8Array(bytes).slice(0, 5))
  if (signature !== '%PDF-') throw new Error('Invoice download failed')
  const objectUrl = URL.createObjectURL(new Blob([bytes], {type: 'application/pdf'}))
  const link = document.createElement('a')
  link.href = objectUrl
  link.download = `invoice-${String(query.order_no).replace(/[^A-Za-z0-9_-]/g, '_')}.pdf`
  document.body.appendChild(link)
  try { link.click() } finally {
    link.remove()
    setTimeout(() => URL.revokeObjectURL(objectUrl), 60000)
  }
}
